import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
 
const AddScore = () => {
  const [compe, setCompe] = useState("basketsmaputra");
  const [team1, setTeam1] = useState("");
  const [team2, setTeam2] = useState("");
  const [score1, setScore1] = useState();
  const [score2, setScore2] = useState();
  const [day, setDay] = useState("1");
  const [quarter11, setQuarter11] = useState(null);
  const [quarter12, setQuarter12] = useState(null);
  const [quarter21, setQuarter21] = useState(null);
  const [quarter22, setQuarter22] = useState(null);
  const [quarter31, setQuarter31] = useState(null);
  const [quarter32, setQuarter32] = useState(null);
  const [quarter41, setQuarter41] = useState(null);
  const [quarter42, setQuarter42] = useState(null);
  const navigate = useNavigate();
 
  const saveScore = async (e) => {
    e.preventDefault();
    try {
      await axios.post("https://livesoc.smakone.org/Scores", {
        compe,
        team1,
        team2,
        score1,
        score2,
        day,
        quarter11,
        quarter12,
        quarter21,
        quarter22,
        quarter31,
        quarter32,
        quarter41,
        quarter42
      });
      navigate("/admin");
    } catch (error) {
      console.log(error);
    }
  };

  function compeChange(e){
    setCompe(e.target.value)
  }
 
  return (
    <div className="columns mt-5 mx-autolyy ,, is-centered text-white font-[JakartaSansBold]">
      <div className="column is-half mx-[100px] lg:mx-[300px]">
        <form onSubmit={saveScore}>
        <div className="field m-3">
            <label className="font-[JakartaSansBold] text-white">Type of Competition</label>
            <div className="control">
              <div className="select is-fullwidth">
                <select
                  value={compe}
                  // onChange={(e) => setCompe(e.target.value)}
                  onChange={compeChange}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 w-fit"
                  >
                  <option value="basketsmaputra">Basket SMA Putra</option>
                  <option value="basketsmaputri">Basket SMA Putri</option>
                  <option value="basketsmpputra">Basket SMP Putra</option>
                  <option value="basketsmpputri">Basket SMP Putri</option>
                  <option value="futsalsmaputra">Futsal SMA Putra</option>
                  <option value="futsalsmaputri">Futsal SMA Putri</option>
                  <option value="futsalsmpputra">Futsal SMP Putra</option>
                  <option value="volismaputra">Voli SMA Putra</option>
                  <option value="volismaputri">Voli SMA Putri</option>
                  <option value="badmintonsmagandaputra">Badminton SMA Ganda Putra</option>
                  <option value="badmintonsmagandaputri">Badminton SMA Ganda Putri</option>
                  <option value="badmintonsmacampur">Badminton SMA Campuran</option>
                  <option value="badmintonsmaberegu">Badminton SMA Beregu</option>
                  <option value="badmintonsmpgandaputri">Badminton SMP Ganda Putra</option>
                  <option value="badmintonsmpgandaputri">Badminton SMP Ganda Campuran</option>
                </select>
              </div>
            </div>
          </div>
          <div className="field m-3">
            <label className="font-[JakartaSansBold] text-white">Name of Team 1</label>
            <div className="control">
              <input
                type="text"
                className="block w-full p-4 text-gray-900 border border-gray-300 rounded-lg bg-gray-50 sm:text-md focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                required
                value={team1}
                onChange={(e) => setTeam1(e.target.value)}
                placeholder="Please input a text (Name of T1)"
              />
            </div>
          </div>
          <div className="field m-3">
            <label className="font-[JakartaSansBold] text-white">Name of Team 2</label>
            <div className="control">
              <input
                type="text"
                className="block w-full p-4 text-gray-900 border border-gray-300 rounded-lg bg-gray-50 sm:text-md focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                required
                value={team2}
                onChange={(e) => setTeam2(e.target.value)}
                placeholder="Please input text (Name of T2)"
              />
            </div>
          </div>
          <div className="field m-3">
            <label className="font-[JakartaSansBold] text-white">Total Score from the Team 1</label>
            <div className="control">
              <input
                inputmode="numeric"
                type="text"
                className="block w-full p-4 text-gray-900 border border-gray-300 rounded-lg bg-gray-50 sm:text-md focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                required
                value={score1}
                onChange={(e) => setScore1(e.target.value)}
                placeholder="Please input a number (Total score of T1)"
              />
            </div>
          </div>
          <div className="field m-3">
            <label className="font-[JakartaSansBold] text-white">Total Score from the Team 2</label>
            <div className="control">
              <input
                inputmode="numeric" 
                type="text"
                className="block w-full p-4 text-gray-900 border border-gray-300 rounded-lg bg-gray-50 sm:text-md focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                required
                value={score2}
                onChange={(e) => setScore2(e.target.value)}
                placeholder="Please input a number (Total score of T2)"
              />
            </div>
          </div>
          <div className="field m-3">
            <label className="font-[JakartaSansBold] text-white">Day of the Match</label>
            <div className="control">
              <div className="select">
                <select
                  value={day}
                  onChange={(e) => setDay(e.target.value)}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 w-fit"
                >
                    <option value="1">22 Oktober</option>
                    <option value="2">23 Oktober</option>
                    <option value="3">24 Oktober</option>
                    <option value="4">25 Oktober</option>
                    <option value="5">26 Oktober</option>
                    <option value="6">27 Oktober</option>
                    <option value="7">28 Oktober</option>
                    <option value="8">29 Oktober</option>
                    <option value="9">30 Oktober</option>
                    <option value="10">31 Oktober</option>
                </select>
              </div>
            </div>
          </div>
          <div className="field m-3">
            <label className="font-[JakartaSansBold] text-white">Score from Quarter 1 of Team 1</label>
            <div className="control">
              <input
                inputmode="numeric"
                type="text"
                className="block w-full p-4 text-gray-900 border border-gray-300 rounded-lg bg-gray-50 sm:text-md focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 "
                value={quarter11}
                onChange={(e) => setQuarter11(e.target.value)}
                placeholder="Please input a number (Q1 of T1)"
              />
            </div>
          </div>
          <div className="field m-3">
            <label className="font-[JakartaSansBold] text-white">Score from Quarter 1 of Team 2</label>
            <div className="control">
              <input
                type="text"
                inputmode="numeric"
                className="block w-full p-4 text-gray-900 border border-gray-300 rounded-lg bg-gray-50 sm:text-md focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                value={quarter12}
                onChange={(e) => setQuarter12(e.target.value)}
                placeholder="Please input a number (Q1 of T2)"
              />
            </div>
          </div>
          <div className="field m-3">
            <label className="font-[JakartaSansBold] text-white">Score from Quarter 2 of Team 1</label>
            <div className="control">
              <input
                type="text"
                inputmode="numeric"
                className="block w-full p-4 text-gray-900 border border-gray-300 rounded-lg bg-gray-50 sm:text-md focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                value={quarter21}
                onChange={(e) => setQuarter21(e.target.value)}
                placeholder="Please input a number (Q2 of T1)"
              />
            </div>
          </div>
          <div className="field m-3">
            <label className="font-[JakartaSansBold] text-white">Score from Quarter 2 of Team 2</label>
            <div className="control">
              <input
                type="text"
                inputmode="numeric"
                className="block w-full p-4 text-gray-900 border border-gray-300 rounded-lg bg-gray-50 sm:text-md focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                value={quarter22}
                onChange={(e) => setQuarter22(e.target.value)}
                placeholder="Please input a number (Q2 of T2)"
              />
            </div>
          </div>
          <div className="field m-3">
            <label className="font-[JakartaSansBold] text-white">Score from Quarter 3 of Team 1</label>
            <div className="control">
              <input
                type="text"
                inputmode="numeric"
                className="block w-full p-4 text-gray-900 border border-gray-300 rounded-lg bg-gray-50 sm:text-md focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                value={quarter31}
                onChange={(e) => setQuarter31(e.target.value)}
                placeholder="Please input a number (Q3 of T1)"
              />
            </div>
          </div>
          <div className="field m-3">
            <label className="font-[JakartaSansBold] text-white">Score from Quarter 3 of Team 2</label>
            <div className="control">
              <input
                type="text"
                inputmode="numeric"
                className="block w-full p-4 text-gray-900 border border-gray-300 rounded-lg bg-gray-50 sm:text-md focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                value={quarter32}
                onChange={(e) => setQuarter32(e.target.value)}
                placeholder="Please input a number (Q3 of T2)"
              />
            </div>
          </div>
          <div className="field m-3">
            <label className="font-[JakartaSansBold] text-white">Score from Quarter 4 of Team 1</label>
            <div className="control">
              <input
                type="text"
                inputmode="numeric"
                className="block w-full p-4 text-gray-900 border border-gray-300 rounded-lg bg-gray-50 sm:text-md focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                value={quarter41}
                onChange={(e) => setQuarter41(e.target.value)}
                placeholder="Please input a number (Q4 of T1)"
              />
            </div>
          </div>
          <div className="field m-3">
            <label className="font-[JakartaSansBold] text-white">Score from Quarter 4 of Team 2</label>
            <div className="control">
              <input
                type="text"
                inputmode="numeric"
                className="block w-full p-4 text-gray-900 border border-gray-300 rounded-lg bg-gray-50 sm:text-md focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                value={quarter42}
                onChange={(e) => setQuarter42(e.target.value)}
                placeholder="Please input a number (Q4 of T2)"
              />
            </div>
          </div>

          <div className="field m-10">
            <button type="submit" className="text-white bg-blue-700 hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded-full text-sm px-5 py-2.5 text-center mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
 
export default AddScore;